import { render } from "./app.vue?vue&type=template&id=27328cf0"
const script = {}

import "./app.vue?vue&type=style&index=0&id=27328cf0&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])